const scorePercentValueGetter = (params, column) => {
  return params.data.resultats?.abcdk?.find((abc) => {
    return abc.label === column.label;
  })?.score_percent;
};

export default scorePercentValueGetter;
